import { createAsyncThunk } from '@reduxjs/toolkit';

import { CreateComment } from 'types/comments';

import commentsService from './commentsService';

export const getComments = createAsyncThunk(
  'applications/getComments',
  async (data: { id: string; isLastOnly?: boolean }, { rejectWithValue }) => {
    try {
      const response = await commentsService.getComments(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createComment = createAsyncThunk(
  'applications/createComment',
  async (data: CreateComment, { rejectWithValue }) => {
    try {
      const response = await commentsService.createComment(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
